import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useMachine } from '@xstate/react';
import { createAIExperienceMachine } from '../utils/xstate/get-ai-experience-service';
export function useAIExperienceService(options) {
  var machineRef = React.useRef(null);
  if (machineRef.current === null) {
    machineRef.current = createAIExperienceMachine(options);
  }

  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var _useMachine = useMachine(machineRef.current),
    _useMachine2 = _slicedToArray(_useMachine, 2),
    state = _useMachine2[0],
    send = _useMachine2[1];
  return {
    // In a later version of xstate -- the type gen means the machine
    // has good types, so these assertions are not required
    state: state.value,
    context: state.context,
    send: send
  };
}